import { Component, OnInit, ViewChild } from "@angular/core";
import { GraphQLClient } from "../../shared/services/graph-qlclient.service";
import gql from "graphql-tag";
import { Observable } from "apollo-client/util/Observable";
import { Observer, Subject } from "rxjs";
import { ruta } from "../../shared/object/ruta.model";
import { sucursal } from "src/app/shared/object/sucursal.model";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { SecurityService } from "../../shared/services/security.service";
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: "app-ruta",
  templateUrl: "./ruta.component.html",
  styleUrls: ["./ruta.component.scss"],
  providers: [SecurityService, ValidadoresService],
})
export class RutaComponent implements OnInit {
  private client: GraphQLClient = null;
  rutaList: ruta[];
  selectedRuta: ruta;
  ruta: ruta;

  public formAgregarRuta: FormGroup;
  public formEditarRuta: FormGroup;

  public activos;
  public inactivos;
  public todos;
  public busquedaEstado;

  public rut_empresa;
  public sucursal_codigo;
  @ViewChild('centralLarge', { static: true }) agregarModal: ModalDirective;
  @ViewChild('centralLargex', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 8;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());


  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService 
  ) {
    this.client = client;
    this.formAgregarRuta = this.construyeFormAgrega();
    this.formEditarRuta = this.construyeFormEdita();
    this.busquedaEstado = 1;

  }

  construyeFormAgrega() {
    return new FormGroup({
      codigo: new FormControl("", [
        Validators.required,
        Validators.maxLength(6),
        Validators.minLength(5),
      ]),
      descripcion: new FormControl("", [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50),
      ]),
      estado: new FormControl(true),
    });
  }

  ValidaQueExisteDatosRuta() {
    let self = this; // this is unused

    this.ruta = {
      codigo: String(this.frmAgregaCodigo.value).toUpperCase(),
      descripcion: this.frmAgregaDescripcion.value,
      empresa_rut: this.rut_empresa,
      sucursal_codigo: this.sucursal_codigo,
      estado: this.frmAgregaEstado.value,
    };

    this.client.query(
      {
        query: gql`
          query($entidad: rutaInputType) {
            ruta {
              existe(entidad: $entidad) {
                respuesta
              }
            }
          }
        `,
        fetchPolicy: "network-only",
        variables: {
          entidad: this.ruta,
        },
      },
      function (respuesta) {
        if (respuesta.data.ruta.existe.respuesta) {
          var res = window.confirm(
            "El código de ruta ya existe. ¿Desea sobreescribir los datos existentes?"
          );
          if (res) {
            self.guardarRuta(self.ruta);
          }
        } else {
          self.insertar();
        }
      }
    );
  }

  construyeFormEdita() {
    return new FormGroup({
      codigo: new FormControl({ value: "", disabled: true }, [
        Validators.required,
        Validators.maxLength(6),
        Validators.minLength(5),
      ]),
      rut_empresa: new FormControl(""),
      sucursal_codigo: new FormControl(""),
      descripcion: new FormControl("", [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50),
      ]),
      estado: new FormControl(true),
    });
  }

  get frmAgregaCodigo() {
    return this.formAgregarRuta.get("codigo");
  }
  get frmAgregaDescripcion() {
    return this.formAgregarRuta.get("descripcion");
  }
  get frmAgregaEstado() {
    return this.formAgregarRuta.get("estado");
  }

  get frmEditarCodigo() {
    return this.formEditarRuta.get("codigo");
  }
  get frmEditarRut_Empresa() {
    return this.formEditarRuta.get("rut_empresa");
  }
  get frmEditarSucursal_Codigo() {
    return this.formEditarRuta.get("sucursal_codigo");
  }
  get frmEditarDescripcion() {
    return this.formEditarRuta.get("descripcion");
  }
  get frmEditarEstado() {
    return this.formEditarRuta.get("estado");
  }

  ngOnInit() {
    this.selectedRuta = {
      codigo: null,
      descripcion: "",
      empresa_rut: null,
      sucursal_codigo: null,
      estado: null,
    };
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursal_codigo = this.accesolocalstorage.getSucursalCodigo();

    this.obtenerRutas(Number(this.rut_empresa), Number(this.sucursal_codigo));
  }

  obtenerRutas(empresa_rut: number, sucursal_codigo: number) {
    let self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query(
            $empresa_rut: Decimal
            $sucursal_codigo: Decimal
            $tipobusqueda: Int
          ) {
            ruta {
              obtenerSegunFiltro(
                filtro: {
                  exacto: {
                    empresa_rut: $empresa_rut
                    sucursal_codigo: $sucursal_codigo
                    tipobusqueda: $tipobusqueda
                  }
                }
              ) {
                respuesta {
                  registros {
                    empresa_rut
                    sucursal_codigo
                    codigo
                    descripcion
                    estado
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: "no-cache",
        variables: {
          empresa_rut: empresa_rut,
          sucursal_codigo: sucursal_codigo,
          tipobusqueda: this.busquedaEstado,
        },
      },
      function (respuesta) {
        self.rutaList =
          respuesta.data.ruta.obtenerSegunFiltro.respuesta.registros;
      }
    );
  }

  insertar() {
    this.selectedRuta.descripcion = this.frmAgregaDescripcion.value;
    this.selectedRuta.codigo = String(this.frmAgregaCodigo.value).toUpperCase();
    this.selectedRuta.empresa_rut = Number(this.rut_empresa);
    this.selectedRuta.sucursal_codigo = Number(this.sucursal_codigo);

    this.postRuta(this.selectedRuta);

    this.selectedRuta = {
      codigo: null,
      descripcion: "",
      empresa_rut: null,
      sucursal_codigo: null,
      estado: null,
    };
  }

  postRuta(ruta: ruta) {
    let self = this;
    var bodyx = ruta;

    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: rutaInputType) {
            ruta {
              agregar(entidad: $entidad) {
                respuesta {
                  empresa_rut
                  sucursal_codigo
                  codigo
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        setTimeout(
          () =>
            self.obtenerRutas(
              Number(self.rut_empresa),
              Number(self.sucursal_codigo)
            ),
          1000
        );
      }
    );
  }

  filtraxEstado() {
    this.obtenerRutas(Number(this.rut_empresa), Number(this.sucursal_codigo));
  }

  guardarRuta(ruta: ruta) {
    let self = this;
    var bodyx = ruta;

    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: rutaInputType) {
            ruta {
              guardar(entidad: $entidad) {
                respuesta {
                  empresa_rut
                  sucursal_codigo
                  codigo
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        setTimeout(
          () =>
            self.obtenerRutas(
              Number(self.rut_empresa),
              Number(self.sucursal_codigo)
            ),
          1000
        );
      }
    );
  }

  muestraModalAgrega() {
    this.selectedRuta = {
      empresa_rut: null,
      sucursal_codigo: null,
      codigo: null,
      descripcion: '',
      estado: true,
    };
    this.formAgregarRuta.reset();
  }

  cambiaEstado(rutaSeleccionada: ruta) {
    if (rutaSeleccionada.estado) {
      rutaSeleccionada.estado = false;
    } else {
      rutaSeleccionada.estado = true;
    }
    this.refrescar(rutaSeleccionada);
  }

  actualizar() {
    this.selectedRuta.codigo = this.frmEditarCodigo.value;
    this.selectedRuta.empresa_rut = this.frmEditarRut_Empresa.value;
    this.selectedRuta.sucursal_codigo = this.frmEditarSucursal_Codigo.value;
    this.selectedRuta.descripcion = this.frmEditarDescripcion.value;
    this.selectedRuta.estado = this.frmEditarEstado.value;
    this.refrescar(this.selectedRuta);
  }
  refrescar(ruta: ruta) {
    let self = this;
    var bodyx = ruta;
    //var self = this;
    delete ruta["__typename"];

    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: rutaInputType) {
            ruta {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.ruta.guardar.respuesta == null) {
          if (respuesta.data.ruta.guardar.mensajes.length > 0) {
            alert(respuesta.data.ruta.guardar.mensajes[0].texto);
          }
        }
        setTimeout(
          () =>
            self.obtenerRutas(
              Number(self.rut_empresa),
              Number(self.sucursal_codigo)
            ),
          1000
        );
      }
    );
  }
  showForEdit(sel_ruta: ruta) {
    this.formEditarRuta.reset();
    this.selectedRuta = Object.assign({}, sel_ruta);
    this.frmEditarDescripcion.setValue(sel_ruta.descripcion);
    this.frmEditarCodigo.setValue(sel_ruta.codigo);
    this.frmEditarRut_Empresa.setValue(sel_ruta.empresa_rut);
    this.frmEditarSucursal_Codigo.setValue(sel_ruta.sucursal_codigo);
    this.frmEditarEstado.setValue(sel_ruta.estado);
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(rutaSeleccionada: ruta) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(rutaSeleccionada);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
